export const pagesPublicIdsEn = {
  title: "Public IDs",
  pageTitle: "Public ID Management",
  addPublicId: "Add Public ID",
  registry: {
    pageTitle: "Public IDs",
    tabs: {
      nationalId: "National ID",
      travelDocument: "Travel Document",
      all: "All",
    },
    categories: {
      nationalId: { title: "National ID" },
      all: { title: "All" },
    },
    filterPlaceholder: "Search by name...",
  },
  detail: {
    pageTitle: "Public ID Details",
    navigationTitle: "Sections",
    tabs: {
      detail: "Details",
      files: "Files",
    },
    files: {
      title: "File List",
      loading: "Loading...",
      error: "Failed to load files",
      empty: "No uploaded files",
      count: "{{count}} items",
      fileName: "File Name",
      actions: "Actions",
      open: "Open",
      fileSize: "Size:",
      uploadDate: "Uploaded:",
      fileType: "Type:",
      preview: "Preview",
      download: "Download",
      deleteFileConfirmTitle: "Delete file?",
    },
    navigation: {
      publicIdCommon: "Public ID Common",
      compliance: "Compliance",
      myNumber: "My Number",
    },
    sections: {
      publicIdCommon: "Public ID Common",
      registration: "Registration Detail",
      myNumber: "My Number",
      nationalRegistrationIdentityCard: "National Registration Identity Card",
    },
    fields: {
      nationalIdType: "National ID Type",
      idNumber: "ID Number",
      issueDate: "Issue Date",
      expiryDate: "Expiry Date",
      issuingAuthority: "Issuing Authority",
      person: "Person",
      country: "Country",
      worker: "Worker",
      lastUpdateDate: "Last Update Date",
      lastUpdater: "Last Updater",
      proofOfPublicId: "Proof of Public ID",
      purposeOfRegistration: "Purpose of Registration",
      legalBasis: "Legal Basis",
      retentionPeriod: "Retention Period",
      myNumber: "My Number",
      status: "Status",
      lastVerificationDate: "Last Verification Date",
      viewProof: "View Proof",
    },
    confirmDelete: {
      description:
        "Are you sure you want to delete the data? This action cannot be undone.",
    },
    deleteData: "Delete Data",
  },
  add: {
    intro: {
      header: {
        headerTitle: "Add Public ID to your Registry",
      },
      body: {
        selectPublicIdType: "Select the Type of Public ID",
        nationalId: {
          title: "National ID",
        },
        itemCard: {
          requiredDetails: "Required details:",
          personId: "Person ID",
          country: "Country",
          purposeOfRegistration: "Purpose of Registration",
          nationalIdType: "National ID Type",
          nationalId: "My Number",
        },
      },
      options: {
        syncIT: "Sync with external Public ID services",
        bulkCsvUpload: {
          title: "Bulk add by uploading CSV file",
          description:
            "You can add data for multiple Public IDs, up to 500 records at a time. A CSV file following the DRESS CODE format is required.",
          button: "Add",
          selectedPublicIdType: "Public ID type",
        },
      },
    },
  },
  importCsv: {
    publicIdType: {
      title: {
        nationalId: "National ID Bulk Import",
      },
      exportFilename: {
        nationalId: "NationalID",
      },
      prepareCsvFile: {
        templateTitle: {
          nationalId: "New National ID",
        },
        updateExisting: {
          nationalId: "Update existing National ID",
        },
      },
      unit: {
        nationalId: "National ID",
      },
    },
    completeDialog: {
      button: "Done",
    },
    checkValidColumn: {
      errors: "errors",
    },
  },
};
